
define('hbs!app/filters/SegmentMenuView.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<ul>\n	<li class=\"menu-dimension\" data-qa=\"menu-set-as-column\">Move to column</li>\n</ul>";
},"useData":true});Handlebars.registerPartial('app/filters/SegmentMenuView.hbs', t);return t;});
